<template>
  <header>
    <div>
      <h1>{{ title }}</h1>
    </div>
  </header>
</template>

<script>
export default {
  name: 'header-component',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  padding: 1rem;
  background: linear-gradient(180deg, #000e40, #1a3776);;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 7rem;

  h1 {
    font-weight: 600;
    font-size: 2.5rem;
    text-align: center;

    @media (max-width: 600px) {
      font-size: 24px;
    }
  }
}

@media (max-width: 600px) {
  header h1 {
    text-align: center;
    font-size: 24px;
  }
}
</style>